import http from '@/services/http';

export const getDeployments = (kb_id, { limit = 10, offset = 0, sort_by_personality_id = null, sort_by_model_type = null } = {}) => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'deployments', {
    params: { kb_id, limit, offset, sort_by_personality_id, sort_by_model_type },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getDeploymentById = (deployment_id, kb_id) => {
  const params = { kb_id }
  return http.get(import.meta.env.VITE_APP_BASE_API + `deployments/${deployment_id}`, {
    params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const createDeployment = (kb_id, deploymentData) => {
  const params = { kb_id }
  return http.post(
    import.meta.env.VITE_APP_BASE_API + 'deployments/',
    {
      deployment_name: deploymentData.deployment_name,
      personality_id: deploymentData.personality_id,
      model_type: deploymentData.model_type,
      allowed_domains: deploymentData.allowed_domains,
      allow_all_domains: deploymentData.allow_all_domains || false
    },
    {
      params,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

export const updateDeployment = (deployment_id, kb_id, deploymentData) => {
  const params = { kb_id }
  return http.patch(
    import.meta.env.VITE_APP_BASE_API + `deployments/${deployment_id}`,
    {
      deployment_name: deploymentData.deployment_name,
      personality_id: deploymentData.personality_id,
      model_type: deploymentData.model_type,
      allowed_domains: deploymentData.allowed_domains,
      allow_all_domains: deploymentData.allow_all_domains
    },
    {
      params,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

export const deleteDeployments = (kb_id, deployment_ids) => {
  return http.delete(import.meta.env.VITE_APP_BASE_API + 'deployments', {
    params: { kb_id },
    data: { deployment_ids },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const searchDeployments = (kb_id, query, { limit = 10, offset = 0 } = {}) => {
  return http.get(import.meta.env.VITE_APP_BASE_API + `deployments/search/${kb_id}`, {
    params: {
      query,
      limit,
      offset
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const checkDeploymentCombo = (kb_id, personality_id, model_type) => {
  return http.get(import.meta.env.VITE_APP_BASE_API + `deployments/${kb_id}/combo-check`, {
    params: {
      personality_id,
      model_type
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
